import React from 'react';
import type { Slot } from '../../types/slot';
import { getCasinosForSlot } from '../../utils/slots';
import { RealMoneyButton } from '../RealMoneyButton';
export function MobileCtaBar({
  slot
}: {
  slot: Slot;
}) {
  const casino = getCasinosForSlot(slot)[0];
  if (!casino) return null;
  return <div className="fixed inset-x-0 bottom-0 z-30 border-t border-line bg-surface px-4 py-3 lg:hidden" data-id="element-355" data-mp="2rw6odukty4ku">
      <div className="flex items-center justify-between gap-3" data-id="element-356" data-mp="2mwty0zur2fdi">
        <div className="min-w-0" data-id="element-357" data-mp="2i5vhbz5unf9q">
          <p className="truncate text-sm font-semibold" data-id="element-358" data-mp="2i5lng0hoonyr">{casino.bonus} bij {casino.name}</p>
          <p className="text-[11px] text-muted" data-id="element-359" data-mp="2e3qmix3o0cli">Advertentie · 18+ · Voorwaarden van toepassing</p>
        </div>
        <RealMoneyButton slot={slot} casino={casino} className="shrink-0" data-id="element-360" data-mp="2968era1dw3f3" />
      </div>
    </div>;
}